import api from '@/api/tecnologico.api'

let servicio = {}

servicio.login = (email, password) => {
  return api.post('/auth/login', { email, password })
}

servicio.sistemasPorUsuario = (idUsuario) => {
  return api.get(`/auth/sistemas/${idUsuario}`)
}

servicio.generarSsoToken = () => {
  return api.get('/auth/sso-token')
}

servicio.olvideMiPassword = (email) => {
  return api.post('/auth/olvide-password', { email })
}

servicio.restablecerPassword = (token, password) => {
  return api.post('/auth/restablecer-password', { token, password })
}

export default servicio
